/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { deliverySettingsResponseSchema } from "./deliverySettingsResponseSchema.ts";

export const orgUnitDeliverySettingsRetrievePathOrgUnitIdSchema = z.uuid();

export const orgUnitDeliverySettingsRetrieveStatus200Schema = deliverySettingsResponseSchema;

export const orgUnitDeliverySettingsRetrieveResponseSchema = orgUnitDeliverySettingsRetrieveStatus200Schema;
